import { Provider } from 'mobx-react';
import * as React from 'react';
import { LoggingService } from '../../services/LoggingService';
import { ContentOrganizerGovernance } from './ContentOrganizerGovernance';
import { ContentOrganizerGovernanceStore } from './store/ContentOrganizerGovernanceStore';

export interface IAContentOrganizerGovernanceProps {
  tenant: string;
  environment: "Development" | "Test" | "Production";
  token: string;
}

export class IAContentOrganizerGovernance extends React.Component<IAContentOrganizerGovernanceProps> {

  private contentOrganizerGovernanceStore: ContentOrganizerGovernanceStore;

  constructor(props: IAContentOrganizerGovernanceProps) {
    super(props);

    LoggingService.init(this.props.environment);

    this.contentOrganizerGovernanceStore = new ContentOrganizerGovernanceStore();
    this.contentOrganizerGovernanceStore.environment = props.environment;
    this.contentOrganizerGovernanceStore.token = props.token;
    this.contentOrganizerGovernanceStore.tenant = props.tenant;
  }

  public render(): JSX.Element {
    return (
      <Provider contentOrganizerGovernanceStore={this.contentOrganizerGovernanceStore}>
        <ContentOrganizerGovernance />
      </Provider>
    )
  }
}